export default function PlayingAnimation() {
  return (
    <div className="flex items-center justify-center gap-[3px] h-4">
      <div className="w-[3px] bg-primary-500 rounded-full animate-playing-bar" style={{ animationDelay: '0ms' }}></div>
      <div className="w-[3px] bg-primary-500 rounded-full animate-playing-bar" style={{ animationDelay: '150ms' }}></div>
      <div className="w-[3px] bg-primary-500 rounded-full animate-playing-bar" style={{ animationDelay: '300ms' }}></div>
      <div className="w-[3px] bg-primary-500 rounded-full animate-playing-bar" style={{ animationDelay: '450ms' }}></div>
    </div>
  );
}
